<script lang="ts">
	import toCloudinaryUrl from '$lib/utils/toCloudinarUrl';
	import Icon from '$lib/components/Icon/Icon.svelte';
	import PostLink from '$lib/components/Post/Tile/PostLink.svelte';
	import { getPostContextStore } from '$lib/components/Post/postContextStore';
	export let target: string;
	export let parent = '';

	// Reference to Bluesuede Post Slab https://github.com/vcilabs/hubs-frontend/blob/master/applications/web/src/app/posts/components/Slab/index.js
	let coefficientWithoutContext = 1.33; // coefficient bluesuede relies on for cloudinary params
	let coefficientWithContext = 1.6; // the avarage coefficient bluesuede relies on for cloudinary params, this changes based on how many lines the post context occupies
	let coefficientForCarouselImage = 1.62;

	const post = getPostContextStore();

	const inCarousel = parent == 'carousel';

	const height = $post.context ? 224 * 2 : 251 * 2; // to match the same quality (same cloudinary params) with bluesuede
	const width = inCarousel
		? 700
		: $post.context
		? Math.round(height * coefficientWithContext)
		: Math.round(height * coefficientWithoutContext);

	$: backgroundImgUrl = $post.title_image
		? toCloudinaryUrl(
				$post.title_image.url,
				width,
				inCarousel ? Math.round(width / coefficientForCarouselImage) : height,
				'balance'
		  )
		: null;

	let icon: null | 'youtube' | 'file' | 'grid' = null;

	if ($post.content_hints.includes('video') || $post.content_hints.includes('audio'))
		icon = 'youtube';
	else if ($post.content_hints.includes('file') || $post.content_hints.includes('document'))
		icon = 'file';
	else if ($post.content_hints.includes('gallery')) icon = 'grid';
</script>

<PostLink {target}>
	{#if $post.title_image}
		{#if inCarousel}
			<div
				class="px-image inCarousel"
				role="img"
				aria-label={$post.context}
				style={`background-image:url(${backgroundImgUrl});`} />
		{:else}
			<div
				class="px-image inStream"
				class:withContext={$post.context}
				role="img"
				aria-label={$post.context}
				style={`background-image:url(${backgroundImgUrl})`} />
		{/if}
	{/if}
	{#if icon}
		<div class="asset-types">
			<Icon {icon} color="white" size="24" />
		</div>
	{/if}
</PostLink>

<style>
	.px-image {
		inline-size: 100%;
		background-repeat: no-repeat;
		background-size: cover;
	}

	.asset-types {
		position: absolute;
		padding: var(--gutterSmall);
		inset-block-end: 0;
		inset-inline-end: 0;
	}

	.inCarousel {
		aspect-ratio: 1.62 / 1;
	}

	.inStream {
		aspect-ratio: 1.33 / 1;
	}

	.withContext {
		aspect-ratio: 1.6 / 1;
	}
</style>
